var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.taskSingleShow,
          expression: "taskSingleShow"
        }
      ],
      staticClass: "popup",
      attrs: { id: "taskSingleTeamTransferPop" }
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "pleaseSelect" } }, [
        _c("div", { staticClass: "title" }, [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("language.popup.cloudTransferPopup.pleaSelect"))
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: { click: _vm.taskSigleClose }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            ref: "aimTree",
            staticClass: "task-content"
          },
          [
            _c(
              "el-scrollbar",
              { ref: "elscrollbar", staticStyle: { height: "100%" } },
              [
                _c("div", [
                  !_vm.model.length && !_vm.loading
                    ? _c(
                        "div",
                        {
                          staticClass: "real-nodrives",
                          on: {
                            click: function($event) {
                              return _vm.toAddCloudPage()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "nondrive-realtime" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "team-nondrive-realtimedes" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("language.teamTransfer.youMust")
                                  ) +
                                  " "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#4755AE",
                                    "font-weight": "bold"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "language.teamTransfer.cloudService"
                                        )
                                      )
                                  )
                                ]
                              ),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("language.teamTransfer.asAdmin")
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tree-nodes", attrs: { id: "treeNodes" } },
                  _vm._l(_vm.model, function(item, index) {
                    return _c("div", { key: index }, [
                      _c(
                        "div",
                        {
                          staticClass: "team-transfer-item",
                          on: {
                            click: function($event) {
                              return _vm.checkedItem(item)
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "icon-util  team-radio-position",
                            class: [
                              _vm.checkItem == item ? "check-radio" : "radio"
                            ],
                            on: {
                              click: function($event) {
                                return _vm.checkedItem(item)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            class: [
                              item.appName ? _vm.returnName(item.appName) : ""
                            ],
                            staticStyle: { position: "relative", top: "3px" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.checkedItem(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("ellipsisNavi")(item.name)) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  }),
                  0
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "task-footer" }, [
          _c(
            "button",
            {
              staticClass: "task-button",
              attrs: { disabled: _vm.bloading },
              on: {
                click: function($event) {
                  return _vm.singleSubmit()
                }
              }
            },
            [
              _vm.bloading
                ? _c("i", {
                    staticClass: "el-icon-loading team-transfer-submit-loading",
                    attrs: { "aria-hidden": "true" }
                  })
                : _c("span", [_vm._v(_vm._s(_vm.$t("language.common.ok")))])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9883556a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9883556a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_transfer_popups/team_transfer_source_popup.vue
// module id = null
// module chunks = 